<mat-card class="daxa-card payments-card mb-25 border-radius bg-white border-none d-block"
  [class.component-dark-theme]="themeService.isDark()" [class.rtl-enabled]="themeService.isRTLEnabled()"
  #stepperContainer>
  <!-- Loading Overlay -->
  <div *ngIf=" isLoadingApplication===true" class="loading-overlay">
    <div class="loading-content">
      <mat-spinner strokeWidth="1" diameter="80"></mat-spinner>
      <span class="loading-text">Fetching your application data...</span>
    </div>
  </div>
  <section class="application-stepper">
    <h3 class="stepper-title">Student Application Form</h3>
    <mat-vertical-stepper [linear]="true" #stepper animationDuration="1000" (selectionChange)="onStepChange($event)">
      <mat-step [stepControl]="formService.programSelectionForm">
        <form [formGroup]="formService.programSelectionForm">
          <ng-template matStepLabel class="template--header">
            <div class="template--header">
              <mat-icon *ngIf="formService?.programSelectionForm?.valid" class="valid">
                check
              </mat-icon>
              <mat-icon class="asterisk invalid"
                *ngIf="formService?.programSelectionForm?.invalid">close</mat-icon><label class="label-head">Select a
                Program</label>
            </div>
          </ng-template>

          <!-- Loading State -->
          <div *ngIf="isLoadingPrograms || isLoadingSchedules" class="loading">
            <!-- <mat-spinner diameter="40"></mat-spinner> -->
            <span>Loading programs and schedules...</span>
          </div>

          <!-- Error State -->
          <div *ngIf="hasError" class="error-message">
            <mat-icon>error_outline</mat-icon>
            <span>Failed to load data. Please refresh the page or try again
              later.</span>
            <button mat-button color="primary" (click)="loadInitialData()">
              Retry
            </button>
          </div>

          <!-- Content when data is loaded -->
          <div *ngIf="!isLoadingPrograms && !isLoadingSchedules && !hasError" class="form-content">
            <div class="row-batch">
              <!-- Program Selection (Always visible) -->
              <div class="form-group">
                <app-ng-autocomplete displayField="programName" [options]="programs"
                  placeholder="Select Academic Program" [control]="
                    $any(formService.programSelectionForm.get('selectProgram'))
                  " error="Program selection is required">
                </app-ng-autocomplete>
              </div>

              <!-- Schedule Selection - Only show when a program is selected -->
              <div class="form-group" *ngIf="
                  formService.programSelectionForm.get('selectProgram')?.value;
                ">
                <app-ng-autocomplete displayField="name" [options]="allScheduleTypes" placeholder="Program Schedule"
                  [control]="
                    $any(formService.programSelectionForm.get('schedule'))
                  " error="Please select a schedule type.">
                </app-ng-autocomplete>

                <mat-hint *ngIf="
                    allScheduleTypes?.length === 0 &&
                    formService.programSelectionForm.get('selectProgram')?.value
                  ">
                  No program schedules available for this program.
                </mat-hint>
              </div>

              <!-- Start Date Selection - Only show when a schedule is selected -->
              <div class="form-group" *ngIf="formService.programSelectionForm.get('schedule')?.value">
                <app-ng-autocomplete [isDate]="true" displayField="startDate" [options]="filteredProgramDates"
                  placeholder="Start Date" [control]="
                    $any(formService.programSelectionForm.get('startDate'))
                  " error="Please select a start date.">
                </app-ng-autocomplete>
                <div *ngIf="!displayHint" class="loading">
                  <mat-spinner diameter="20" strokeWidth="1"></mat-spinner>
                  <span>loading program dates...</span>
                </div>
                <mat-hint style="color: #ba1a1a" *ngIf="displayHint && filteredProgramDates?.length === 0">
                  No available dates for this program schedule. <br />
                  Select another combination
                </mat-hint>
              </div>
              <div class="form-group">
                <mat-form-field appearance="fill" class="mat-input-body">
                  <mat-label>Why did you choose this program?</mat-label>
                  <textarea matInput type="text" [formControl]="
                    $any(formService.programSelectionForm.get('reasonForApplication'))
                  "></textarea>
                  <mat-error *ngIf="
                    formService.programSelectionForm
                      .get('reasonForApplication')
                      ?.hasError('required')
                  ">
                    Enter your reason
                  </mat-error>
                </mat-form-field>
              </div>
            </div>


            <!-- Validation Summary -->
            <div *ngIf="
                formService.programSelectionForm.invalid &&
                formService.programSelectionForm.touched &&
                !displayHint
              " class="validation-summary">
              <mat-icon>warning</mat-icon>
              <span>Please complete all required fields to continue.</span>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="btn-group">
            <button [disabled]="formService.programSelectionForm.invalid"
              (click)="onSaveContinueLater(formService.programSelectionForm)" class="save-continue" type="button"
              [disabled]="isSubmittingApplication">
              Save & Continue Later</button>
            <button (click)="onSubmit(formService.programSelectionForm)" mat-flat-button class="daxa stepper-btn-next"
              type="button" [disabled]="
                isSubmittingApplication || formService.programSelectionForm.invalid
              " [class.loading]="isSubmittingApplication">
              <span *ngIf="!isSubmittingApplication">Save & Next</span>
              <span *ngIf="isSubmittingApplication" class="loading-ellipsis">Saving<span class="dot one">.</span><span
                  class="dot two">.</span><span class="dot three">.</span></span>

            </button>
          </div>
        </form>
      </mat-step>

      <mat-step [stepControl]="formService.programInfoForm" label="Program Information">
        <ng-template matStepLabel class="template--header">
          <div class="template--header">
            <mat-icon *ngIf="formService.programInfoForm.valid" class="valid">
              check
            </mat-icon>
            <mat-icon class="asterisk invalid" *ngIf="formService.programInfoForm.invalid">close</mat-icon>
            <label class="label-head">Program Information</label>
          </div>
        </ng-template>

        <ng-template class="w-70" matStepContent>
          <form [formGroup]="formService.programInfoForm" class="info-form-column mt-4">
            <div class="d-flex mb-3 gap-2">
              <mat-form-field class="form-field" appearance="fill">
                <mat-label>Program Title</mat-label>
                <input readonly matInput formControlName="programTitle" placeholder="Program Title" />
                <mat-error *ngIf="
                                formService.programInfoForm.get('programTitle')?.hasError('required')
                              ">
                  Program Title is required.
                </mat-error>
              </mat-form-field>

              <mat-form-field class="form-field" appearance="fill">
                <mat-label>Completion Award</mat-label>
                <input matInput formControlName="completionAward" placeholder="Completion Award" readonly />
                <mat-error *ngIf="
                                formService.programInfoForm.get('completionAward')?.hasError('required')
                              ">
                  Completion Award is required.
                </mat-error>
              </mat-form-field>
            </div>

            <div class="d-flex flex-wrap gap-2 justify-content-center align-items-center mb-3">
              <div class="w-100">
                <h6 class="text-center">Program Duration</h6>
                <div class="d-flex gap-2">
                  <mat-form-field class="form-field" appearance="fill">
                    <mat-label>Start Date</mat-label>

                    <input matInput formControlName="startDate" placeholder="Start Date" readonly />
                    <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                    <mat-datepicker #startPicker></mat-datepicker>
                    <mat-error *ngIf="
                                    formService.programInfoForm.get('startDate')?.hasError('required')
                                  ">
                      Date is required.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field class="form-field" appearance="fill">
                    <mat-label>End Date</mat-label>
                    <input matInput formControlName="endDate" placeholder="End Date" readonly />
                    <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                    <mat-datepicker #endPicker></mat-datepicker>
                    <mat-error *ngIf="
                                    formService.programInfoForm.get('endDate')?.hasError('required')
                                  ">
                      End Date is required.
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="w-100">
                <h6 class="text-center">General Class Time</h6>
                <div class="d-flex gap-2">
                  <mat-form-field class="form-field" appearance="fill">
                    <mat-label>Start Time</mat-label>
                    <input readonly matInput formControlName="startTime" placeholder="Start Time" [disabled]="true" />
                    <mat-error *ngIf="
                                    formService.programInfoForm.get('startTime')?.hasError('required')
                                  ">
                      Start Time is required.
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div [class.component-dark-theme]="themeService.isDark()" [class.rtl-enabled]="themeService.isRTLEnabled()"
              formGroupName="classDays">
              <h6 class="text-center">SPECIFIC CLASS DAYS</h6>

              <div class="table-responsive">
                <table [formGroup]="$any(formService.programInfoForm.get('classDays'))"
                  class="table table-bordered table-striped">
                  <thead class="thead-light">
                    <tr>
                      <th scope="col">Monday</th>
                      <th scope="col">Tuesday</th>
                      <th scope="col">Wednesday</th>
                      <th scope="col">Thursday</th>
                      <th scope="col">Friday</th>
                      <th scope="col">Saturday</th>
                      <th scope="col">Sunday</th>
                      <th scope="col">Online Flex</th>
                      <th scope="col">Online Hybrid Flex</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input class="form-control" readonly formControlName="monday" placeholder="Type..." />
                      </td>
                      <td>
                        <input class="form-control" readonly formControlName="tuesday" placeholder="Type..." />
                      </td>
                      <td>
                        <input class="form-control" readonly formControlName="wednesday" placeholder="Type..." />
                      </td>
                      <td>
                        <input class="form-control" formControlName="thursday" placeholder="Type..." readonly />
                      </td>
                      <td>
                        <input class="form-control" readonly formControlName="friday" placeholder="Type..." />
                      </td>
                      <td>
                        <input class="form-control" readonly formControlName="saturday" placeholder="Type..." />
                      </td>
                      <td>
                        <input class="form-control" readonly formControlName="sunday" placeholder="Type..." />
                      </td>
                      <td>
                        <input class="form-control" readonly formControlName="onlineFlex" placeholder="Type..." />
                      </td>
                      <td>
                        <input class="form-control" readonly formControlName="onlineHybridFlex" placeholder="Type..." />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="d-flex gap-2 w-100">
              <h6>PROGRAM DURATION</h6>

              <div class="d-flex gap-2 w-100">
                <mat-form-field class="form-field" appearance="fill">
                  <mat-label>Duration</mat-label>
                  <input readonly type="text" matInput formControlName="programDuration" placeholder="Duration" />
                </mat-form-field>
              </div>
            </div>

            <section class="mt-4 p-3 border rounded">
              <h4 class="mb-3">
                <span class="text-black fw-bold">❖</span> Clinicals Days:
                <small class="text-black">
                  Clinical externship hours are completed during the week for
                  all programs.
                </small>
              </h4>
              <h4 class="mb-3">
                <span class="text-black fw-bold">❖</span> Clinical Time:
                <small class="text-black">
                  Clinical externship start time and end time may vary from 5:30
                  am - 3:30 pm or 1:30 pm - 11:30 pm depending on the clinical
                  site.
                </small>
              </h4>
              <h4 class="mb-3">
                <span class="text-black fw-bold">❖</span> Class Start & End
                Time:
                <small class="text-black">
                  Specific Program’s Start and End times are published on the
                  Program/Course syllabus shown to you during enrollment. The
                  Program/Course syllabus shall be given to Students on the
                  first day of class and can also be accessed on the Student’s
                  Moodle Account.
                </small>
              </h4>
              <h4 class="mb-3">
                <span class="text-black fw-bold">❖</span> Online Hybrid Flex:
                <small class="text-black">
                  The Online Hybrid Flex program has either physical lab skills,
                  clinical externship or both requiring physical attendance.
                  Only theory is part of the course is completed online.
                </small>
              </h4>
              <h4 class="mb-3">
                <span class="text-black fw-bold">❖</span> Online Flex:
                <small class="text-black">
                  The Online Flex is completed 100% online. No skills lab or
                  clinical externship required.
                </small>
              </h4>
              <h4 class="mb-0">
                <span class="text-black fw-bold">❖</span> Course Schedule:
                <small class="text-black">
                  For a complete detailed course schedule, refer to the specific
                  course/Program you are enrolling in.
                </small>
              </h4>
            </section>

            <div class="btn-group">
              <button mat-flat-button color="warn" class="mr-15 stepper-btn-back" matStepperPrevious>
                Back
              </button>

              <button (click)="onSaveContinueLater()" class="save-continue" type="submit">
                Save & Continue later</button>
              <button mat-flat-button class="daxa stepper-btn-next" matStepperNext>
                Save & Next
              </button>
            </div>
          </form>
        </ng-template>
      </mat-step>
      <!-- Second stepper form personal info -->
      <mat-step [stepControl]="formService.personalInfoForm">
        <form [formGroup]="formService.personalInfoForm" (ngSubmit)="onSubmit(formService.personalInfoForm)">
          <ng-template matStepLabel class="template--header">
            <div class="template--header">
              <mat-icon *ngIf="formService.personalInfoForm.valid" class="valid">
                check
              </mat-icon>
              <mat-icon class="asterisk invalid" *ngIf="formService?.personalInfoForm?.invalid">close</mat-icon><label
                class="label-head">Student Personal Information</label>
            </div>
          </ng-template>
          <div class="row-batch">
            <div class="form-group">
              <mat-form-field appearance="fill" class="mat-input-body">
                <mat-label>First Name</mat-label>
                <input matInput type="text" [formControl]="
                    $any(formService.personalInfoForm.get('firstName'))
                  " />
                <mat-error *ngIf="
                    formService.personalInfoForm
                      .get('firstName')
                      ?.hasError('required')
                  ">
                  First Name is required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field appearance="fill" class="mat-input-body">
                <mat-label>Middle Name</mat-label>
                <input matInput type="text" formControlName="middleName" />
                <!-- No validation error needed as middleName is optional -->
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field appearance="fill" class="mat-input-body">
                <mat-label>Last Name</mat-label>
                <input matInput type="text" formControlName="lastName" />
                <mat-error *ngIf="
                    formService.personalInfoForm
                      .get('lastName')
                      ?.hasError('required')
                  ">
                  Last Name is required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <app-date-picker appearance="fill" (dateSelected)="onDateSelected($event)" [agelimit]="true"
                placeholder="Date of Birth" [dateControl]="
                  $any(formService.personalInfoForm.get('dateOfBirth'))
                " error="Date of Birth is required"></app-date-picker>
              <p style="padding-top: 5px; font-size: 14px">
                Must be 16 years of Age
              </p>
            </div>

            <div class="form-group">
              <mat-form-field appearance="fill" class="mat-input-body">
                <mat-label>Social Security Number</mat-label>
                <input matInput formControlName="ssn" mask="000-00-0000" placeholder="000-00-0000" />
                <mat-error *ngIf="
                    formService.personalInfoForm
                      .get('ssn')
                      ?.hasError('required')
                  ">
                  Social Security Number is required
                </mat-error>
                <mat-error *ngIf="
                    formService.personalInfoForm
                      .get('ssn')
                      ?.hasError('minlength')
                  ">
                  Social Security Number must be at least 8 characters long
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field appearance="fill" class="mat-input-body">
                <mat-label>Email Address</mat-label>
                <input matInput type="email" readonly formControlName="email" />
                <mat-error *ngIf="
                    formService.personalInfoForm
                      .get('email')
                      ?.hasError('required')
                  ">
                  Email Address is required
                </mat-error>
                <mat-error *ngIf="
                    formService.personalInfoForm.get('email')?.hasError('email')
                  ">
                  Enter a valid email address
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field appearance="fill" class="mat-input-body">
                <mat-label>Phone Number </mat-label>
                <input matInput type="text" placeholder="EX: +1 (405) 345-1342" prefix="+1 " mask="(000) 000-0000"
                  formControlName="phoneNumber" />
                <mat-error *ngIf="
                    formService.personalInfoForm
                      .get('phoneNumber')
                      ?.hasError('required')
                  ">
                  Phone Number is required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field appearance="fill" class="mat-input-body">
                <mat-label>Street Address</mat-label>
                <input matInput type="text" formControlName="streetAddress" />
                <mat-error *ngIf="
                    formService.personalInfoForm
                      .get('streetAddress')
                      ?.hasError('required')
                  ">
                  Street Address is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-group">
              <mat-form-field appearance="fill" class="mat-input-body">
                <mat-label>Zip Code</mat-label>
                <input matInput type="text" maxlength="5" (input)="onZipInput($event, 'zipcode')"
                  (blur)="handleZipCode($event, 'zipcode')" formControlName="zipCode" />
                <mat-error *ngIf="
                    formService.personalInfoForm
                      .get('zipCode')
                      ?.hasError('required')
                  ">
                  Zip Code is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-group">
              <mat-form-field appearance="fill" class="mat-input-body">
                <mat-label>City</mat-label>
                <input readonly matInput type="text" formControlName="city" />
                <mat-error *ngIf="
                    formService.personalInfoForm
                      .get('city')
                      ?.hasError('required')
                  ">
                  City is required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field appearance="fill" class="mat-input-body">
                <mat-label>State</mat-label>
                <input readonly matInput type="text" formControlName="state" />
                <mat-error *ngIf="
                    formService.personalInfoForm
                      .get('state')
                      ?.hasError('required')
                  ">
                  State is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <mat-checkbox (change)="onPermanentAddressChecked($event.checked)">Permanent Address (if different than
            present Address)</mat-checkbox>

          <div class="row-batch" *ngIf="permanentAddressChecked">
            <div class="form-group">
              <mat-form-field appearance="fill" class="mat-input-body">
                <mat-label>Permanent Street Address</mat-label>
                <input matInput type="text" formControlName="permanentStreetAddress" />
                <mat-error *ngIf="
                    formService.personalInfoForm
                      .get('permanentStreetAddress')
                      ?.hasError('required')
                  ">
                  Permanent Street Address is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-group">
              <mat-form-field appearance="fill" class="mat-input-body">
                <mat-label>Permanent Zip Code</mat-label>
                <input matInput type="text" maxlength="5" (input)="onZipInput($event, 'pzipcode')"
                  (blur)="handleZipCode($event, 'pzipcode')" formControlName="permanentZipCode" />
                <mat-error *ngIf="
                    formService.personalInfoForm
                      .get('permanentZipCode')
                      ?.hasError('required')
                  ">
                  Permanent Zip Code is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-group">
              <mat-form-field appearance="fill" class="mat-input-body">
                <mat-label>Permanent City</mat-label>
                <input matInput readonly type="text" formControlName="permanentCity" />
                <mat-error *ngIf="
                    formService.personalInfoForm
                      .get('permanentCity')
                      ?.hasError('required')
                  ">
                  Permanent City is required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field appearance="fill" class="mat-input-body">
                <mat-label>Permanent State</mat-label>
                <input readonly matInput type="text" formControlName="permanentState" />
                <mat-error *ngIf="
                    formService.personalInfoForm
                      .get('permanentState')
                      ?.hasError('required')
                  ">
                  Permanent State is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <br />
          <mat-checkbox [formControl]="
              $any(formService.personalInfoForm.get('messageConsent'))
            " (change)="onCheckConsent($event.checked)">May we call,text ,email and or send you automated messages to
            your
            cell phone or email</mat-checkbox>
          <div class="btn-group">
            <button mat-flat-button color="warn" class="mr-15 stepper-btn-back" matStepperPrevious>
              Back
            </button>

            <button [disabled]="formService.personalInfoForm.invalid"
              (click)="onSaveContinueLater(formService.personalInfoForm)" class="save-continue" type="submit">
              Save & Continue later
            </button>
            <button mat-flat-button class="daxa stepper-btn-next" type="submit"
              [disabled]="isSubmittingPersonalInfo || formService.personalInfoForm.invalid">
              <span *ngIf="!isSubmittingPersonalInfo">Save & Next</span> <span *ngIf="isSubmittingPersonalInfo"
                class="loading-ellipsis">Saving<span class="dot one">.</span><span class="dot two">.</span><span
                  class="dot three">.</span></span>
            </button>
          </div>
        </form>
      </mat-step>
      <!-- third stepper form Emergency Contact -->
      <mat-step [stepControl]="formService.emergencyContactForm">
        <form [formGroup]="formService.emergencyContactForm" (ngSubmit)="onSubmit(formService.emergencyContactForm)">
          <ng-template matStepLabel class="template--header">
            <div class="template--header">
              <mat-icon *ngIf="formService?.emergencyContactForm?.valid" class="valid">
                check
              </mat-icon>
              <mat-icon class="asterisk invalid" *ngIf="formService?.emergencyContactForm?.invalid">close</mat-icon>
              <label class="label-head">Emergency Contact</label>
            </div>
          </ng-template>
          <div class="row-batch">
            <div class="form-group">
              <mat-form-field appearance="fill" class="mat-input-body">
                <mat-label>First Name</mat-label>
                <input matInput type="text" formControlName="emergencyFirstName" />
                <mat-error *ngIf="
                    formService.emergencyContactForm
                      .get('emergencyFirstName')
                      ?.hasError('required')
                  ">
                  First Name is required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field appearance="fill" class="mat-input-body">
                <mat-label>Middle Name</mat-label>
                <input matInput type="text" formControlName="emergencyMiddleName" />
                <!-- No validation error needed as middleName is optional -->
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field appearance="fill" class="mat-input-body">
                <mat-label>Last Name</mat-label>
                <input matInput type="text" formControlName="emergencyLastName" />
                <mat-error *ngIf="
                    formService.emergencyContactForm
                      .get('emergencyLastName')
                      ?.hasError('required')
                  ">
                  Last Name is required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field appearance="fill" class="mat-input-body">
                <mat-label>Email Address</mat-label>
                <input matInput type="email" formControlName="emergencyEmailAddress" />
                <mat-error *ngIf="
                    formService.emergencyContactForm
                      .get('emergencyEmailAddress')
                      ?.hasError('required')
                  ">
                  Email Address is required
                </mat-error>
                <mat-error *ngIf="
                    formService.emergencyContactForm
                      .get('emergencyEmailAddress')
                      ?.hasError('email')
                  ">
                  Enter a valid email address
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field appearance="fill" class="mat-input-body">
                <mat-label>Phone Number</mat-label>
                <!-- <input matInput type="text" /> -->
                <input matInput type="text" formControlName="emergencyPhoneNumber" placeholder="EX: +1 (405) 345-1342"
                  prefix="+1 " mask="(000) 000-0000" />
                <mat-error *ngIf="
                    formService.emergencyContactForm
                      .get('emergencyPhoneNumber')
                      ?.hasError('required')
                  ">
                  Phone Number is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-group">
              <mat-form-field appearance="fill" class="mat-input-body">
                <mat-label>Full address</mat-label>
                <input matInput type="text" formControlName="fulladdress" />
                <mat-error *ngIf="
                    formService.emergencyContactForm
                      .get('fulladdress')
                      ?.hasError('required')
                  ">
                  full address is required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <app-ng-autocomplete [options]="relationships" placeholder="Relationship" [control]="
                  $any(formService.emergencyContactForm.get('relationship'))
                " error="Relationship is required">
              </app-ng-autocomplete>
            </div>
          </div>

          <div class="btn-group">
            <button mat-flat-button color="warn" class="mr-15 stepper-btn-back" matStepperPrevious>
              Back
            </button>

            <button [disabled]="isSubmittingEmergencyContact||formService.emergencyContactForm.invalid"
              (click)="onSaveContinueLater(formService.emergencyContactForm)" class="save-continue" type="submit">
              Save & Continue later</button><button mat-flat-button class="daxa stepper-btn-next" type="submit"
              [disabled]="
                isSubmittingEmergencyContact || formService.emergencyContactForm.invalid
              ">
              <span *ngIf="!isSubmittingEmergencyContact">Save & Next</span> <span *ngIf="isSubmittingEmergencyContact"
                class="loading-ellipsis">Saving<span class="dot one">.</span><span class="dot two">.</span><span
                  class="dot three">.</span></span>
            </button>
          </div>
        </form>
      </mat-step>
      <!-- fourth stepper form Ethnicity  -->
      <mat-step [stepControl]="formService.ethnicityForm">
        <form [formGroup]="formService.ethnicityForm" (ngSubmit)="onSubmit(formService.ethnicityForm)">
          <ng-template matStepLabel class="template--header">
            <div class="template--header">
              <mat-icon *ngIf="formService?.ethnicityForm?.valid" class="valid">
                check
              </mat-icon>
              <mat-icon class="asterisk invalid" *ngIf="formService?.ethnicityForm?.invalid">close</mat-icon><label
                class="label-head">Ethnicity</label>
            </div>
          </ng-template>
          <div class="row-batch">
            <app-ng-autocomplete [options]="['Female', 'Male', 'Other']"
              [control]="$any(formService.ethnicityForm.get('gender'))" placeholder="Gender"
              error="Gender is required" />
            <app-ng-autocomplete [options]="[
                'Asian',
                'Black',
                'Hispanic',
                'Native American',
                'Pacific Islander',
                'White'
              ]" [control]="$any(formService.ethnicityForm.get('ethnicity'))" placeholder="Ethnicity"
              error="Ethnicity is required" />
          </div>
          <div class="btn-group">
            <button mat-flat-button color="warn" class="mr-15 stepper-btn-back" matStepperPrevious>
              Back
            </button>

            <button [disabled]="isSubmittingEthnicity||formService.ethnicityForm.invalid"
              (click)="onSaveContinueLater(formService.ethnicityForm)" class="save-continue" type="submit">
              Save & Continue later</button><button mat-flat-button class="daxa stepper-btn-next" type="submit"
              [disabled]="isSubmittingEthnicity || formService.ethnicityForm.invalid">
              <span *ngIf="!isSubmittingEthnicity">Save & Next</span> <span *ngIf="isSubmittingEthnicity"
                class="loading-ellipsis">Saving<span class="dot one">.</span><span class="dot two">.</span><span
                  class="dot three">.</span></span>
            </button>
          </div>
        </form>
      </mat-step>
      <!-- fifth stepper disability form -->
      <mat-step [stepControl]="formService.disabilityForm">
        <form [formGroup]="formService.disabilityForm" (ngSubmit)="onSubmit(formService.disabilityForm)">
          <ng-template matStepLabel class="template--header">
            <div class="template--header">
              <mat-icon *ngIf="formService?.disabilityForm?.valid" class="valid">
                check
              </mat-icon>
              <mat-icon class="asterisk invalid" *ngIf="formService?.disabilityForm?.invalid">close</mat-icon><label
                class="label-head">Disabilities</label>
            </div>
          </ng-template>

          <section class="toggle-state-options">
            <p>
              Do you have any form of Disability that you want {{ (tenant$ | async)?.name || 'The Institution' }} to be
              aware of and offer accommodation?
            </p>
            <mat-radio-group formControlName="disabilityPresence" class="radio-btn">
              <mat-radio-button (click)="onToggleDisability('Yes')" value="Yes">Yes</mat-radio-button>
              <mat-radio-button (click)="onToggleDisability('No')" value="No">No</mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="
                formService.disabilityForm
                  .get('disabilityPresence')
                  ?.hasError('required') &&
                formService.disabilityForm.get('disabilityPresence')?.touched
              ">
              This field is required
            </mat-error>
          </section>

          <div class="row-batch" *ngIf="toggleDisability">
            <div class="form-group">
              <app-ng-autocomplete [options]="disabilities" placeholder="Disability"
                (selected)="onOptionSelected($event)" [control]="$any(formService.disabilityForm.get('disability'))"
                error="disability is required" />
            </div>

            <div class="form-group">
              <app-ng-autocomplete [options]="accommodations" placeholder="Type of accommodation" [control]="
                  $any(formService.disabilityForm.get('typeOfAccommodation'))
                " error="accommodation required" />
            </div>
          </div>
          <div class="btn-group">
            <button mat-flat-button color="warn" class="mr-15 stepper-btn-back" matStepperPrevious>
              Back
            </button>

            <button [disabled]="isSubmittingDisability||formService.disabilityForm.invalid"
              (click)="onSaveContinueLater(formService.disabilityForm)" class="save-continue" type="submit">
              Save & Continue later</button><button mat-flat-button class="daxa stepper-btn-next" type="submit"
              [disabled]="isSubmittingDisability || formService.disabilityForm.invalid">
              <span *ngIf="!isSubmittingDisability">Save & Next</span> <span *ngIf="isSubmittingDisability"
                class="loading-ellipsis">Saving<span class="dot one">.</span><span class="dot two">.</span><span
                  class="dot three">.</span></span>
            </button>
          </div>
        </form>
      </mat-step>

      <mat-step [stepControl]="formService.studentSourceForm">
        <form [formGroup]="formService.studentSourceForm" (ngSubmit)="onSubmit(formService.studentSourceForm)">
          <ng-template matStepLabel class="template--header">
            <div class="template--header">
              <mat-icon *ngIf="formService?.studentSourceForm?.valid" class="valid">
                check
              </mat-icon>
              <mat-icon class="asterisk invalid" *ngIf="formService?.studentSourceForm?.invalid">close</mat-icon><label
                class="label-head">Student Source</label>
            </div>
          </ng-template>
          <div class="row-batch">
            <app-ng-autocomplete [options]="sources" placeholder="How did you hear about  Our College?"
              error="source required" [control]="$any(formService.studentSourceForm.get('source'))"
              (selected)="onSelectSource($event)" />
          </div>
          <div class="row-batch">
            <mat-form-field *ngIf="isOther" appearance="fill" class="mat-input-body form-group">
              <mat-label>Enter your source </mat-label>
              <textarea matInput formControlName="studentSourceText"></textarea>
              <mat-error *ngIf="
                  formService.studentSourceForm
                    .get('studentSourceText')
                    ?.hasError('required')
                ">
                This field is required.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="btn-group">
            <button mat-flat-button color="warn" class="mr-15 stepper-btn-back" matStepperPrevious>
              Back
            </button>

            <button [disabled]="!formService.studentSourceForm.valid"
              (click)="onSaveContinueLater(formService.studentSourceForm)" class="save-continue" type="submit">
              Save & Continue later</button><button mat-flat-button class="daxa stepper-btn-next" type="submit"
              [disabled]="isSubmittingStudentSource || formService.studentSourceForm.invalid">
              <span *ngIf="!isSubmittingStudentSource">Save & Next</span> <span *ngIf="isSubmittingStudentSource"
                class="loading-ellipsis">Saving<span class="dot one">.</span><span class="dot two">.</span><span
                  class="dot three">.</span></span>
            </button>
          </div>
        </form>
      </mat-step>
      <div *ngIf="
          StudentApplicationData?.isShortCourseSelected === false ||
          StudentApplicationData?.isShortCourseSelected === null
        ">
        <!-- Sixth stepper form Program Options -->
        <mat-step [stepControl]="formService.practicalNursingForm"
          *ngIf="StudentApplicationData?.isPreNursingCourseSelected">
          <form [formGroup]="formService.practicalNursingForm" (ngSubmit)="onSubmit(formService.practicalNursingForm)">
            <ng-template matStepLabel class="template--header">
              <div class="template--header">
                <mat-icon *ngIf="formService?.practicalNursingForm?.valid" class="valid">
                  check
                </mat-icon>
                <mat-icon class="asterisk invalid"
                  *ngIf="formService?.practicalNursingForm?.invalid">close</mat-icon><label class="label-head">Program
                  Options</label>
              </div>
            </ng-template>
            <p>
              Have you completed the following Pre-Nursing Courses with at least
              a grade of C?
            </p>

            <div class="prenursing-section">
              <p>Human Anatomy & Physiology 1</p>
              <mat-radio-group formControlName="humanAnatomyAndPhysiology1" (change)="onCourseSelectionChange()"
                class="radio-btn">
                <mat-radio-button value="Yes">Yes</mat-radio-button>
                <mat-radio-button value="No">No</mat-radio-button>
              </mat-radio-group>
            </div>

            <div class="prenursing-section">
              <p>Human Anatomy & Physiology II</p>
              <mat-radio-group formControlName="humanAnatomyAndPhysiology2" (change)="onCourseSelectionChange()"
                class="radio-btn">
                <mat-radio-button value="Yes">Yes</mat-radio-button>
                <mat-radio-button value="No">No</mat-radio-button>
              </mat-radio-group>
            </div>

            <div class="prenursing-section">
              <p>Medical Terminology</p>
              <mat-radio-group formControlName="medicalTerminology" (change)="onCourseSelectionChange()"
                class="radio-btn">
                <mat-radio-button value="Yes">Yes</mat-radio-button>
                <mat-radio-button value="No">No</mat-radio-button>
              </mat-radio-group>
            </div>

            <div class="prenursing-section">
              <p>Pharmacology of Nursing</p>
              <mat-radio-group formControlName="pharmacologyOfNursing" (change)="onCourseSelectionChange()"
                class="radio-btn">
                <mat-radio-button value="Yes">Yes</mat-radio-button>
                <mat-radio-button value="No">No</mat-radio-button>
              </mat-radio-group>
            </div>

            <div class="form-group doc-bg" *ngIf="
                humanAnatomyAndPhysiology1FileUpload ||
                humanAnatomyAndPhysiology2FileUpload ||
                medicalTerminologyFileUpload ||
                pharmacologyOfNursingFileUpload
              ">
              <app-ng-fileupload [isMultiple]="false" labelText="Provide transcript(s)" fileId="pnaTranscript"
                [fileBlobUrl]="transcriptUploadUrl" [fileName]="StudentApplicationData?.transcriptUploadName"
                (filesSelected)="
                  handleTranscripts(
                    $event,
                    formService.practicalNursingForm,
                    'transcript'
                  )
                " [control]="
                  $any(formService.practicalNursingForm.get('transcript'))
                " error="transcript required">
              </app-ng-fileupload>
            </div>
            <div *ngIf="
                humanAnatomyAndPhysiology1Course ||
                humanAnatomyAndPhysiology2Course ||
                medicalTerminologyCourse ||
                pharmacologyOfNursingCourse
              ">
              <p>Select the required Pre-Nursing Course</p>

              <mat-checkbox formControlName="preNursing"
                (change)="onPreNursingCheck($event.checked)">Pre-Nursing</mat-checkbox>
              <div class="pre-nursing-option" *ngIf="toggleRequiredPreNursingCourses">
                <mat-checkbox formControlName="humanAnatomyAndPhysiology1Course"
                  *ngIf="humanAnatomyAndPhysiology1Course">
                  Human Anatomy and Physiology I
                </mat-checkbox>
                <mat-checkbox formControlName="humanAnatomyAndPhysiology2Course"
                  *ngIf="humanAnatomyAndPhysiology2Course">
                  Human Anatomy and Physiology II
                </mat-checkbox>
                <mat-checkbox formControlName="medicalTerminologyCourse" *ngIf="medicalTerminologyCourse">
                  Medical Terminology
                </mat-checkbox>
                <mat-checkbox formControlName="pharmacologyOfNursingCourse" *ngIf="pharmacologyOfNursingCourse">
                  Pharmacology of Nursing
                </mat-checkbox>
              </div>
              <br />
              <mat-checkbox formControlName="refresher" (change)="onRefresherCheck($event.checked)">Refresher
                course</mat-checkbox>
              <div class="form-group" *ngIf="toggleRefresherCheckBox">
                <mat-form-field appearance="fill" class="mat-input-body">
                  <mat-label>Which Refresher Course</mat-label>
                  <input matInput type="text" formControlName="refresherCourse" />
                  <mat-error *ngIf="
                      formService.practicalNursingForm
                        .get('refresherCourse')
                        ?.hasError('required')
                    ">
                    refresher course is required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <!-- Navigation Buttons -->
            <div class="btn-group">
              <button mat-flat-button color="warn" class="mr-15 stepper-btn-back" matStepperPrevious>
                Back
              </button>

              <button [disabled]="isSubmittingPracticalNursing|| !formService.practicalNursingForm.valid"
                (click)="onSaveContinueLater(formService.practicalNursingForm)" class="save-continue" type="submit">
                Save & Continue later
              </button>
              <button mat-flat-button class="daxa stepper-btn-next" type="submit"
                [disabled]="isSubmittingPracticalNursing||formService.practicalNursingForm.invalid">
                <span *ngIf="!isSubmittingPracticalNursing">Save & Next</span> <span
                  *ngIf="isSubmittingPracticalNursing" class="loading-ellipsis">Saving<span
                    class="dot one">.</span><span class="dot two">.</span><span class="dot three">.</span></span>
              </button>
            </div>
          </form>
        </mat-step>
        <!-- seventh stepper form Student verification  -->
        <mat-step [stepControl]="formService.studentVerificationForm">
          <form [formGroup]="formService.studentVerificationForm"
            (ngSubmit)="onSubmit(formService.studentVerificationForm)">
            <ng-template matStepLabel class="template--header">
              <div class="template--header">
                <mat-icon *ngIf="formService?.studentVerificationForm?.valid" class="valid">
                  check
                </mat-icon>
                <mat-icon class="asterisk invalid"
                  *ngIf="formService?.studentVerificationForm?.invalid">close</mat-icon><label
                  class="label-head">Student Verification</label>
              </div>
            </ng-template>
            <div class="row-batch">
              <section class="toggle-state-options">
                <p>
                  Are you taking this Program at {{ (tenant$ | async)?.name || 'The Institution' }} for the
                  first time?
                </p>
                <mat-radio-group formControlName="firstTimeProgram" class="radio-btn">
                  <mat-radio-button value="Yes">Yes</mat-radio-button>
                  <mat-radio-button value="No">No</mat-radio-button>
                </mat-radio-group>
                <mat-error *ngIf="
                    formService.studentVerificationForm
                      .get('firstTimeProgram')
                      ?.hasError('required') &&
                    formService.studentVerificationForm.get('firstTimeProgram')
                      ?.touched
                  ">
                  This field is required
                </mat-error>
              </section>
              <section class="toggle-state-options">
                <p>
                  Are you retaking this Program, having taken the Program in
                  another School?
                </p>
                <mat-radio-group formControlName="retakingProgram" class="radio-btn">
                  <mat-radio-button value="Yes">Yes</mat-radio-button>
                  <mat-radio-button value="No">No</mat-radio-button>
                </mat-radio-group>
                <mat-error *ngIf="
                    formService.studentVerificationForm
                      .get('retakingProgram')
                      ?.hasError('required') &&
                    formService.studentVerificationForm.get('retakingProgram')
                      ?.touched
                  ">
                  This field is required
                </mat-error>
              </section>
              <section class="toggle-state-options">
                <p>
                  Have you taken any other Program at {{ (tenant$ | async)?.name || 'The Institution' }} in
                  the past?
                </p>
                <mat-radio-group formControlName="pastProgram" class="radio-btn">
                  <mat-radio-button value="Yes">Yes</mat-radio-button>
                  <mat-radio-button value="No">No</mat-radio-button>
                </mat-radio-group>
                <mat-error *ngIf="
                    formService.studentVerificationForm
                      .get('pastProgram')
                      ?.hasError('required') &&
                    formService.studentVerificationForm.get('pastProgram')
                      ?.touched
                  ">
                  This field is required
                </mat-error>
              </section>
            </div>
            <div class="btn-group">
              <button mat-flat-button color="warn" class="mr-15 stepper-btn-back" matStepperPrevious>
                Back
              </button>

              <button [disabled]="isSubmittingVerification|| !formService.studentVerificationForm.valid" (click)="
                  onSaveContinueLater(formService.studentVerificationForm)
                " class="save-continue" type="submit">
                Save & Continue later</button><button mat-flat-button class="daxa stepper-btn-next" type="submit"
                [disabled]="isSubmittingVerification||!formService.studentVerificationForm.valid">
                <span *ngIf="!isSubmittingVerification">Save & Next</span> <span *ngIf="isSubmittingVerification"
                  class="loading-ellipsis">Saving<span class="dot one">.</span><span class="dot two">.</span><span
                    class="dot three">.</span></span>
              </button>
            </div>
          </form>
        </mat-step>
        <!-- eighth stepper form Student source  -->

        <!-- nineth stepper form us military record  -->
        <mat-step [stepControl]="formService.usMilitaryRecordForm">
          <form [formGroup]="formService.usMilitaryRecordForm" (ngSubmit)="onSubmit(formService.usMilitaryRecordForm)">
            <ng-template matStepLabel class="template--header">
              <div class="template--header">
                <mat-icon *ngIf="formService?.usMilitaryRecordForm?.valid" class="valid">
                  check
                </mat-icon>
                <mat-icon class="asterisk invalid"
                  *ngIf="formService?.usMilitaryRecordForm?.invalid">close</mat-icon><label class="label-head">US
                  Military Record</label>
              </div>
            </ng-template>

            <section class="toggle-state-options">
              <p>Are you a current Military Personnel or a Veteran?</p>
              <mat-radio-group formControlName="currentMilitaryOrVeteran" class="radio-btn">
                <mat-radio-button value="Yes" (click)="onToggleMilitary('Yes')">Yes</mat-radio-button>
                <mat-radio-button value="No" (click)="onToggleMilitary('No')">No</mat-radio-button>
              </mat-radio-group>
              <mat-error *ngIf="
                  formService.usMilitaryRecordForm
                    .get('currentMilitaryOrVeteran')
                    ?.hasError('required') &&
                  formService.usMilitaryRecordForm.get(
                    'currentMilitaryOrVeteran'
                  )?.touched
                ">
                This field is required
              </mat-error>
            </section>

            <div class="column-batch" *ngIf="toggoleMilitary">
              <section class="toggle-state-options">
                <p>Which Military Branch did you serve in?</p>
                <mat-radio-group formControlName="militaryBranch" class="radio-btn">
                  <mat-radio-button value="Marine corps">Marine corps</mat-radio-button>
                  <mat-radio-button value="Air force">Air force</mat-radio-button>
                  <mat-radio-button value="Navy seals">Navy seals</mat-radio-button>
                  <mat-radio-button value="Coast guard">Coast guard</mat-radio-button>
                  <mat-radio-button value="Space force">Space force</mat-radio-button>
                </mat-radio-group>
                <mat-error *ngIf="
                    formService.usMilitaryRecordForm
                      .get('militaryBranch')
                      ?.hasError('required') &&
                    formService.usMilitaryRecordForm.get('militaryBranch')
                      ?.touched
                  ">
                  This field is required
                </mat-error>
              </section>

              <div class="row-batch">
                <app-date-picker appearance="fill" placeholder="Start date" [dateControl]="
                    $any(formService.usMilitaryRecordForm.get('startDate'))
                  " error="start date is required"></app-date-picker>
                <app-date-picker appearance="fill" placeholder="End date" [dateControl]="
                    $any(formService.usMilitaryRecordForm.get('endDate'))
                  " error="end date required"></app-date-picker>
              </div>

              <section class="toggle-state-options">
                <p class="mat-label-custom">
                  How were you discharged from the military?
                </p>
                <mat-radio-group formControlName="dischargeStatus" class="radio-btn">
                  <mat-radio-button value="Bad conduct">Bad conduct</mat-radio-button>
                  <mat-radio-button value="Honorable">Honorable</mat-radio-button>
                  <mat-radio-button value="Under other than honorable conditions">Under other than honorable
                    conditions</mat-radio-button>
                  <mat-radio-button value="Under honorable conditions (General)">Under honorable conditions
                    (General)</mat-radio-button>
                  <mat-radio-button value="Dishonorable">Dishonorable</mat-radio-button>
                  <mat-radio-button value="Uncharacterized">Uncharacterized</mat-radio-button>
                </mat-radio-group>
                <mat-error *ngIf="
                    formService.usMilitaryRecordForm
                      .get('dischargeStatus')
                      ?.hasError('required') &&
                    formService.usMilitaryRecordForm.get('dischargeStatus')
                      ?.touched
                  ">
                  This field is required
                </mat-error>
              </section>
            </div>

            <div class="btn-group">
              <button mat-flat-button color="warn" class="mr-15 stepper-btn-back" matStepperPrevious>
                Back
              </button>

              <button [disabled]="isSubmittingMilitary|| !formService.usMilitaryRecordForm.valid"
                (click)="onSaveContinueLater(formService.usMilitaryRecordForm)" class="save-continue" type="submit">
                Save & Continue later</button><button mat-flat-button class="daxa stepper-btn-next"
                [disabled]="isSubmittingMilitary||formService.usMilitaryRecordForm.invalid">
                <span *ngIf="!isSubmittingMilitary">Save & Next</span> <span *ngIf="isSubmittingMilitary"
                  class="loading-ellipsis">Saving<span class="dot one">.</span><span class="dot two">.</span><span
                    class="dot three">.</span></span>
              </button>
            </div>
          </form>
        </mat-step>
        <!-- tenth stepper form Educational background  -->
        <mat-step [stepControl]="formService.educationalBackgroundForm">
          <form [formGroup]="formService.educationalBackgroundForm"
            (ngSubmit)="onSubmit(formService.educationalBackgroundForm)">
            <ng-template matStepLabel class="template--header">
              <div class="template--header">
                <mat-icon *ngIf="formService?.educationalBackgroundForm?.valid" class="valid">
                  check
                </mat-icon>
                <mat-icon class="asterisk invalid"
                  *ngIf="formService?.educationalBackgroundForm?.invalid">close</mat-icon><label
                  class="label-head">Educational Background</label>
              </div>
            </ng-template>

            <!-- Autocomplete for Highest Education Level -->
            <app-ng-autocomplete [options]="educationLevels" placeholder="Highest level of education"
              error="level of education required" [control]="
                $any(
                  formService.educationalBackgroundForm.get('highestEducation')
                )
              " (selected)="onSelectElementary($event)">
            </app-ng-autocomplete>

            <!-- Can Read/Write English -->
            <div *ngIf="!elementary" class="toggle-state-options">
              <p>Can you read, write, and comprehend the English language?</p>
              <mat-radio-group formControlName="canReadWriteEnglish" class="radio-btn">
                <mat-radio-button value="Yes">Yes</mat-radio-button>
                <mat-radio-button value="No">No</mat-radio-button>
              </mat-radio-group>
              <mat-error *ngIf="
                  formService.educationalBackgroundForm
                    .get('canReadWriteEnglish')
                    ?.hasError('required') &&
                  formService.educationalBackgroundForm.get(
                    'canReadWriteEnglish'
                  )?.touched
                ">
                this field is required
              </mat-error>
            </div>

            <div *ngIf="elementary">
              <!-- High School Information -->
              <div class="row-batch">
                <div class="form-group">
                  <mat-form-field appearance="fill" class="mat-input-body">
                    <mat-label>Name of high school you graduated from</mat-label>
                    <input matInput type="text" formControlName="highSchoolName" />
                    <mat-error *ngIf="
                        formService.educationalBackgroundForm
                          .get('highSchoolName')
                          ?.hasError('required') &&
                        formService.educationalBackgroundForm.get(
                          'highSchoolName'
                        )?.touched
                      ">
                      This field is required
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="form-group">
                  <app-ng-autocomplete [options]="years" placeholder="Which year did you graduate from High School?"
                    [control]="
                      $any(
                        formService.educationalBackgroundForm.get(
                          'highSchoolGraduationYear'
                        )
                      )
                    " error="year is required">
                  </app-ng-autocomplete>
                </div>
              </div>

              <!-- College Information -->
              <section class="toggle-state-options">
                <p>
                  Did you graduate from College/Vocational School/Trade School?
                </p>
                <mat-radio-group formControlName="graduatedCollege" class="radio-btn">
                  <mat-radio-button (click)="onToggleCollegeGraduant('Yes')" value="Yes">Yes</mat-radio-button>
                  <mat-radio-button (click)="onToggleCollegeGraduant('No')" value="No">No</mat-radio-button>
                </mat-radio-group>
                <mat-error *ngIf="
                    formService.educationalBackgroundForm
                      .get('graduatedCollege')
                      ?.hasError('required') &&
                    formService.educationalBackgroundForm.get(
                      'graduatedCollege'
                    )?.touched
                  ">
                  this field is required
                </mat-error>
              </section>

              <div class="row-batch" *ngIf="toggleCollegeGraduant">
                <div class="form-group">
                  <mat-form-field appearance="fill" class="mat-input-body">
                    <mat-label>Month & year did you graduate from?</mat-label>
                    <input matInput type="text" formControlName="collegeGraduationMonthYear" />
                    <mat-error *ngIf="
                        formService.educationalBackgroundForm
                          .get('collegeGraduationMonthYear')
                          ?.hasError('required')
                      ">
                      month and year is required
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="form-group">
                  <mat-form-field appearance="fill" class="mat-input-body">
                    <mat-label>College you attended and graduated from?</mat-label>
                    <input matInput type="text" formControlName="collegeName" />
                    <mat-error *ngIf="
                        formService.educationalBackgroundForm
                          .get('collegeName')
                          ?.hasError('required')
                      ">
                      college is required
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="form-group">
                  <mat-form-field appearance="fill" class="mat-input-body">
                    <mat-label>What was your major?</mat-label>
                    <input matInput type="text" formControlName="major" />
                    <mat-error *ngIf="
                        formService.educationalBackgroundForm
                          .get('major')
                          ?.hasError('required')
                      ">
                      major is required
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="form-group">
                  <mat-form-field appearance="fill" class="mat-input-body">
                    <mat-label>What was your GPA?</mat-label>
                    <input matInput type="text" formControlName="gpa" />
                    <mat-error *ngIf="
                        formService.educationalBackgroundForm
                          .get('gpa')
                          ?.hasError('required')
                      ">
                      GPA is required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <!-- University Information -->
              <section class="toggle-state-options" *ngIf="toggleCollegeGraduant">
                <p>Did you graduate from the University?</p>
                <mat-radio-group formControlName="graduatedUniversity" class="radio-btn">
                  <mat-radio-button (click)="onToggleVarsityIfCollege('Yes')" value="Yes">Yes</mat-radio-button>
                  <mat-radio-button (click)="onToggleVarsityIfCollege('No')" value="No">No</mat-radio-button>
                </mat-radio-group>
                <mat-error *ngIf="
                    formService.educationalBackgroundForm
                      .get('graduatedUniversity')
                      ?.hasError('required') &&
                    formService.educationalBackgroundForm.get(
                      'graduatedUniversity'
                    )?.touched
                  ">
                  This field is required
                </mat-error>
              </section>

              <div class="row-batch" *ngIf="toggleVarsityIfCollege">
                <div class="form-group">
                  <mat-form-field appearance="fill" class="mat-input-body">
                    <mat-label>Which month & year did you graduate?</mat-label>
                    <input matInput type="text" formControlName="universityGraduationMonthYear" />
                    <mat-error *ngIf="
                        formService.educationalBackgroundForm
                          .get('universityGraduationMonthYear')
                          ?.hasError('required')
                      ">
                      This field is required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <!-- Navigation Buttons -->
            <div class="btn-group">
              <button mat-flat-button color="warn" class="mr-15 stepper-btn-back" matStepperPrevious>
                Back
              </button>

              <button [disabled]="isSubmittingEducation|| !formService.educationalBackgroundForm.valid" (click)="
                  onSaveContinueLater(formService.educationalBackgroundForm)
                " class="save-continue" type="submit">
                Save & Continue later</button><button
                [disabled]="isSubmittingEducation|| !formService.educationalBackgroundForm.valid" mat-flat-button
                class="daxa stepper-btn-next" type="submit">
                <span *ngIf="!isSubmittingEducation">Save & Next</span> <span *ngIf="isSubmittingEducation"
                  class="loading-ellipsis">Saving<span class="dot one">.</span><span class="dot two">.</span><span
                    class="dot three">.</span></span>
              </button>
            </div>
          </form>
        </mat-step>
        <!-- eleventh stepper form Employment & work experience  -->
        <mat-step [stepControl]="formService.employmentForm">
          <form [formGroup]="formService.employmentForm" (ngSubmit)="onSubmit(formService.employmentForm)">
            <ng-template matStepLabel class="template--header">
              <div class="template--header">
                <mat-icon *ngIf="formService?.employmentForm?.valid" class="valid">
                  check
                </mat-icon>
                <mat-icon class="asterisk invalid" *ngIf="formService?.employmentForm?.invalid">close</mat-icon><label
                  class="label-head">Employment & Work Experience</label>
              </div>
            </ng-template>
            <section class="toggle-state-options">
              <p>Are you currently employed?</p>
              <mat-radio-group class="radio-btn" formControlName="employmentStatus">
                <mat-radio-button value="Yes" (click)="onToggleEmploymentStatus('Yes')">Yes</mat-radio-button>
                <mat-radio-button value="No" (click)="onToggleEmploymentStatus('no')">No</mat-radio-button>
              </mat-radio-group>
              <mat-error *ngIf="
                  formService.employmentForm
                    .get('employmentStatus')
                    ?.hasError('required') &&
                  formService.employmentForm.get('employmentStatus')?.touched
                ">
                This field is required
              </mat-error>
            </section>
            <div class="row-batch" *ngIf="toggleEmploymentStatus">
              <div class="form-group">
                <mat-form-field appearance="fill" class="mat-input-body">
                  <mat-label> Name of your employer? </mat-label>
                  <input matInput formControlName="employerName" />
                  <mat-error *ngIf="
                      formService.employmentForm
                        .get('employerName')
                        ?.hasError('required') &&
                      formService.employmentForm.get('employerName')?.touched
                    ">
                    Employer name is required.
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-group">
                <app-date-picker appearance="fill" (dateSelected)="onDateSelected($event)"
                  placeholder="When did you start working for this employer?" [dateControl]="
                    $any(formService.employmentForm.get('startDate'))
                  " error="Start date is required."></app-date-picker>
              </div>
              <div class="form-group">
                <mat-form-field appearance="fill" class="mat-input-body">
                  <mat-label> What is your position? </mat-label>
                  <input matInput formControlName="position" />
                  <mat-error *ngIf="
                      formService.employmentForm
                        .get('position')
                        ?.hasError('required') &&
                      formService.employmentForm.get('position')?.touched
                    ">
                    Position is required.
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-group">
                <mat-form-field appearance="fill" class="mat-input-body">
                  <mat-label> What is your hourly pay? </mat-label>
                  <input type="number" matInput formControlName="hourlypay" />
                  <mat-error *ngIf="
                      formService.employmentForm
                        .get('hourlyPay')
                        ?.hasError('required') &&
                      formService.employmentForm.get('position')?.touched
                    ">
                    pay is required.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <mat-checkbox (change)="onCheckCurrentEmploymentStatus($event.checked)" *ngIf="toggleEmploymentStatus"
              formControlName="isCurrentlyWorkingForEmployer">Are you currently working for this
              employer?</mat-checkbox>
            <div class="btn-group">
              <button mat-flat-button color="warn" class="mr-15 stepper-btn-back" matStepperPrevious>
                Back
              </button>

              <button [disabled]="isSubmittingEmployment|| !formService.employmentForm.valid"
                (click)="onSaveContinueLater(formService.employmentForm)" class="save-continue" type="submit">
                Save & Continue later</button>

              <button mat-flat-button class="daxa stepper-btn-next" type="submit"
                [disabled]="isSubmittingEmployment||formService.employmentForm.invalid">
                <span *ngIf="!isSubmittingEmployment">Save & Next</span> <span *ngIf="isSubmittingEmployment"
                  class="loading-ellipsis">Saving<span class="dot one">.</span><span class="dot two">.</span><span
                    class="dot three">.</span></span>
              </button>

            </div>
          </form>
        </mat-step>
        <!-- twelveth stepper form Citizenship  -->
        <mat-step [stepControl]="formService.citizenshipForm">
          <form [formGroup]="formService.citizenshipForm" (ngSubmit)="onSubmit(formService.citizenshipForm)">
            <ng-template matStepLabel class="template--header">
              <div class="template--header">
                <mat-icon *ngIf="formService?.citizenshipForm?.valid" class="valid">
                  check
                </mat-icon>
                <mat-icon class="asterisk invalid" *ngIf="formService?.citizenshipForm?.invalid">close</mat-icon><label
                  class="label-head">Citizenship</label>
              </div>
            </ng-template>
            <div class="row-batch">
              <app-ng-autocomplete [options]="countries" placeholder="Which country were you born in" [control]="
                  $any(formService.citizenshipForm.get('countryOfBirth'))
                " error="select a country" (selected)="onOptionSelected($event)"></app-ng-autocomplete>
              <section class="toggle-state-options" [ngStyle]="{ width: '450px' }">
                <p>Are you a U.S citizen?</p>
                <mat-radio-group class="radio-btn" formControlName="usCitizen">
                  <mat-radio-button (click)="onToggleCitizenship('Yes')" value="Yes">Yes</mat-radio-button>
                  <mat-radio-button (click)="onToggleCitizenship('No')" value="No">No</mat-radio-button>
                </mat-radio-group>
                <mat-error *ngIf="
                    formService.citizenshipForm
                      .get('usCitizen')
                      ?.hasError('required') &&
                    formService.citizenshipForm.get('usCitizen')?.touched
                  ">
                  Please select an option.
                </mat-error>
              </section>
            </div>
            <div class="row-batch" *ngIf="toggleCitizenship">
              <app-ng-autocomplete [options]="countries" placeholder="Country of citizenship" [control]="
                  $any(formService.citizenshipForm.get('countryOfCitizenship'))
                " error="select a country" (selected)="onOptionSelected($event)"></app-ng-autocomplete>
              <section class="toggle-state-options" [ngStyle]="{ width: '450px' }">
                <p>Are you a U.S permanent resident?</p>
                <mat-radio-group class="radio-btn" formControlName="permanentResidentStatus">
                  <mat-radio-button (click)="onTogglePermanentResident('Yes')" value="Yes">Yes</mat-radio-button>
                  <mat-radio-button (click)="onTogglePermanentResident('No')" value="No">No</mat-radio-button>
                </mat-radio-group>
                <mat-error *ngIf="
                    formService.citizenshipForm
                      .get('permanentResidentStatus')
                      ?.hasError('required') &&
                    formService.citizenshipForm.get('permanentResidentStatus')
                      ?.touched
                  ">
                  Please select an option.
                </mat-error>
              </section>
            </div>
            <div class="row-batch">
              <div class="form-group" *ngIf="permanentResident">
                <mat-form-field appearance="fill" class="mat-input-body">
                  <mat-label> Alien Number </mat-label>
                  <input matInput formControlName="alienNumber" />
                  <mat-error *ngIf="
                      formService.citizenshipForm
                        .get('alienNumber')
                        ?.hasError('required') &&
                      formService.citizenshipForm.get('alienNumber')?.touched
                    ">
                    Alien number is required.
                  </mat-error>
                </mat-form-field>
              </div>
              <section class="toggle-state-options" [ngStyle]="{ width: '450px' }" *ngIf="notResident">
                <p>Are you an Immigrant/Qualified alien?</p>
                <mat-radio-group class="radio-btn" formControlName="qualifiedImmigrant">
                  <mat-radio-button (click)="onToggleQualifiedImmigrant('Yes')" value="Yes">Yes</mat-radio-button>
                  <mat-radio-button (click)="onToggleQualifiedImmigrant('No')" value="No">No</mat-radio-button>
                </mat-radio-group>
                <mat-error *ngIf="
                    formService.citizenshipForm
                      .get('qualifiedImmigrant')
                      ?.hasError('required') &&
                    formService.citizenshipForm.get('qualifiedImmigrant')
                      ?.touched
                  ">
                  Please select an option.
                </mat-error>
              </section>
            </div>
            <div class="row-batch" *ngIf="qualifiedImmigrant">
              <section class="toggle-state-options" [ngStyle]="{ width: '450px' }">
                <p>Are you in USA on visa</p>
                <mat-radio-group class="radio-btn" formControlName="hasVisa">
                  <mat-radio-button value="Yes">Yes</mat-radio-button>
                  <mat-radio-button value="No">No</mat-radio-button>
                </mat-radio-group>
                <mat-error *ngIf="
                    formService.citizenshipForm
                      .get('hasVisa')
                      ?.hasError('required') &&
                    formService.citizenshipForm.get('hasVisa')?.touched
                  ">
                  Please select an option.
                </mat-error>
              </section>
              <div class="form-group" *ngIf="qualifiedImmigrant">
                <mat-form-field appearance="fill" class="mat-input-body">
                  <mat-label> What is your I-94 </mat-label>
                  <input matInput formControlName="I94" />
                  <mat-error *ngIf="
                      formService.citizenshipForm
                        .get('I94')
                        ?.hasError('required') &&
                      formService.citizenshipForm.get('I94')?.touched
                    ">
                    I-94 is required.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="btn-group">

              <button mat-flat-button color="warn" class="mr-15 stepper-btn-back" matStepperPrevious>
                Back
              </button>
              <button [disabled]="isSubmitting|| !formService.citizenshipForm.valid"
                (click)="onSaveContinueLater(formService.citizenshipForm)" class="save-continue" type="submit">
                Save & Continue later</button>

              <button mat-flat-button class="daxa stepper-btn-next" type="submit"
                [disabled]="isSubmittingCitizenship||formService.citizenshipForm.invalid">
                <span *ngIf="!isSubmittingCitizenship">Save & Next</span>
                <span *ngIf=" isSubmittingCitizenship" class="loading-ellipsis">Saving<span
                    class="dot one">.</span><span class="dot two">.</span><span class="dot three">.</span></span>
              </button>

            </div>
          </form>
        </mat-step>
        <!-- thirteenth stepper form Background info  -->
        <mat-step [stepControl]="formService.backgroundInfoForm">
          <form [formGroup]="formService.backgroundInfoForm" (ngSubmit)="onSubmit(formService.backgroundInfoForm)">
            <ng-template matStepLabel class="template--header">
              <div class="template--header">
                <mat-icon *ngIf="formService?.backgroundInfoForm?.valid" class="valid">
                  check
                </mat-icon>
                <mat-icon class="asterisk invalid"
                  *ngIf="formService?.backgroundInfoForm?.invalid">close</mat-icon><label class="label-head">Background
                  Information</label>
              </div>
            </ng-template>

            <p>
              If you answer YES to any of the questions below, you must explain
              by writing in the space provided below after questions. The
              explanation for a YES answer should include, but not be limited
              to: <br />
              1) State and/or jurisdiction. <br />
              2) Nature of complaint/offense. <br />
              3) Disposition of complaint and/or offense (e.g., “dismissed
              insufficient evidence,” “deferred sentence”).
              <br />
              4) Date of disposition. <br />
              5) Attach a copy of any correspondence received by you, the
              Applicant, regarding the complaint/offense.
            </p>

            <!-- Question 1 -->
            <section class="toggle-state-options">
              <p>
                Have you ever: <br />
                1) Participated in a first offender program; <br />
                2) Deferred adjudication or other Program or arrangement where
                adjudication has been withheld; <br />
                3) Pleaded guilty or no contest; <br />
                4) Been convicted; <br />
                5) Received a deferred sentence; <br />
                6) Been sentenced for any criminal offense in any State or U.S.
                jurisdiction regardless of whether this matter has been expunged
                or otherwise removed?
              </p>
              <mat-radio-group class="radio-btn" formControlName="criminalHistory"
                (change)="onToggleBackgroundInfo('Q1', $event.value)">
                <mat-radio-button value="Yes">Yes</mat-radio-button>
                <mat-radio-button value="No">No</mat-radio-button>
              </mat-radio-group>
              <mat-form-field *ngIf="toggleBackgroundInfoQone" appearance="fill" class="mat-input-body">
                <mat-label>Enter your reasons</mat-label>
                <textarea matInput formControlName="reasonOne"></textarea>
                <mat-error *ngIf="
                    formService.backgroundInfoForm
                      .get('reasonOne')
                      ?.hasError('required')
                  ">
                  This field is required.
                </mat-error>
              </mat-form-field>
            </section>

            <!-- Question 2 -->
            <section class="toggle-state-options">
              <p>
                Have you ever been found in violation of any state, U.S.
                jurisdiction, or federal law regulating the Practice of a
                healthcare profession?
              </p>
              <mat-radio-group class="radio-btn" formControlName="healthcareViolation"
                (change)="onToggleBackgroundInfo('Q2', $event.value)">
                <mat-radio-button value="Yes">Yes</mat-radio-button>
                <mat-radio-button value="No">No</mat-radio-button>
              </mat-radio-group>
              <mat-form-field *ngIf="toggleBackgroundInfoQtwo" appearance="fill" class="mat-input-body">
                <mat-label>Enter your reasons</mat-label>
                <textarea matInput formControlName="reasonTwo"></textarea>
                <mat-error *ngIf="
                    formService.backgroundInfoForm
                      .get('reasonTwo')
                      ?.hasError('required')
                  ">
                  This field is required.
                </mat-error>
              </mat-form-field>
            </section>

            <!-- Question 3 -->
            <section class="toggle-state-options">
              <p>
                Do you have any disciplinary actions or allegations, pending or
                substantiated, against you or your Certification or health care
                professional license in any state or U.S. jurisdiction?
              </p>
              <mat-radio-group class="radio-btn" formControlName="disciplinaryActions"
                (change)="onToggleBackgroundInfo('Q3', $event.value)">
                <mat-radio-button value="Yes">Yes</mat-radio-button>
                <mat-radio-button value="No">No</mat-radio-button>
              </mat-radio-group>
              <mat-form-field *ngIf="toggleBackgroundInfoQthree" appearance="fill" class="mat-input-body">
                <mat-label>Enter your reasons</mat-label>
                <textarea matInput formControlName="reasonThree"></textarea>
                <mat-error *ngIf="
                    formService.backgroundInfoForm
                      .get('reasonThree')
                      ?.hasError('required')
                  ">
                  This field is required.
                </mat-error>
              </mat-form-field>
            </section>

            <!-- Question 4 -->
            <section class="toggle-state-options">
              <p>
                Have you had any certificate, license, registration, or other
                privileges to practice a health care profession denied, revoked,
                suspended, restricted, reprimanded, censured, or placed on
                probation by a state or U.S. jurisdiction, federal or foreign
                authority, or have you ever surrendered such credential to avoid
                or in connection with, action by such authority?
              </p>
              <mat-radio-group class="radio-btn" formControlName="credentialActions"
                (change)="onToggleBackgroundInfo('Q4', $event.value)">
                <mat-radio-button value="Yes">Yes</mat-radio-button>
                <mat-radio-button value="No">No</mat-radio-button>
              </mat-radio-group>
              <mat-form-field *ngIf="toggleBackgroundInfoQfour" appearance="fill" class="mat-input-body">
                <mat-label>Enter your reasons</mat-label>
                <textarea matInput formControlName="reasonFour"></textarea>
                <mat-error *ngIf="
                    formService.backgroundInfoForm
                      .get('reasonFour')
                      ?.hasError('required')
                  ">
                  This field is required.
                </mat-error>
              </mat-form-field>
            </section>

            <div class="btn-group">
              <button mat-flat-button class="mr-15 stepper-btn-back" matStepperPrevious>
                Back
              </button>

              <button [disabled]="isSubmittingBackground|| !formService.backgroundInfoForm.valid"
                (click)="onSaveContinueLater(formService.backgroundInfoForm)" class="save-continue" type="submit">
                Save & Continue later</button>
              <button mat-flat-button class="daxa stepper-btn-next" type="submit"
                [disabled]="isSubmittingBackground||!formService.backgroundInfoForm.valid">
                <span *ngIf="!isSubmittingBackground">Save & Next</span><span *ngIf="isSubmittingBackground"
                  class="loading-ellipsis">Saving<span class="dot one">.</span><span class="dot two">.</span><span
                    class="dot three">.</span></span>
              </button>

            </div>
          </form>
        </mat-step>
        <!-- fourteenth stepper form Applicant's certification  -->
        <mat-step [stepControl]="formService.certificationForm">
          <form [formGroup]="formService.certificationForm" (ngSubmit)="onSubmit(formService.certificationForm)">
            <ng-template matStepLabel class="template--header">
              <div class="template--header">
                <mat-icon *ngIf="formService?.certificationForm?.valid" class="valid">
                  check
                </mat-icon>
                <mat-icon class="asterisk invalid"
                  *ngIf="formService?.certificationForm?.invalid">close</mat-icon><label class="label-head">Applicant's
                  Certification and Agreement</label>
              </div>
            </ng-template>

            <p [ngStyle]="{ 'text-transform': 'uppercase' }">
              Please Read Carefully - If you answer 'NO' to any of the questions
              below, explain in the space after the question.
            </p>

            <!-- Question 1 -->
            <section class="toggle-state-options">
              <p>
                I understand that the School has the right to conduct my
                criminal background check.
              </p>
              <mat-radio-group formControlName="toggleone" (change)="onToggleCertification('Q1', $event.value)">
                <mat-radio-button value="Yes">Yes</mat-radio-button>
                <mat-radio-button value="No">No</mat-radio-button>
              </mat-radio-group>
              <mat-error *ngIf="
                  formService.certificationForm
                    .get('toggleone')
                    ?.hasError('required') &&
                  formService.certificationForm.get('toggleone')?.touched
                ">
                this field is required
              </mat-error>
              <mat-form-field *ngIf="toggleCertificationQone" appearance="fill">
                <mat-label>Enter your reasons</mat-label>
                <textarea matInput formControlName="reasonOne"></textarea>
                <mat-error *ngIf="
                    formService.certificationForm
                      .get('reasonOne')
                      ?.hasError('required')
                  ">
                  This field is required.
                </mat-error>
              </mat-form-field>
            </section>

            <!-- Question 2 -->
            <section class="toggle-state-options">
              <p>
                I understand that I may be required to take a random drug
                screening test as part of the clinical attendance requirement.
              </p>
              <mat-radio-group formControlName="toggletwo" (change)="onToggleCertification('Q2', $event.value)">
                <mat-radio-button value="Yes">Yes</mat-radio-button>
                <mat-radio-button value="No">No</mat-radio-button>
              </mat-radio-group>
              <mat-error *ngIf="
                  formService.certificationForm
                    .get('toggletwo')
                    ?.hasError('required') &&
                  formService.certificationForm.get('toggletwo')?.touched
                ">
                this field is required
              </mat-error>
              <mat-form-field *ngIf="toggleCertificationQtwo" appearance="fill">
                <mat-label>Enter your reasons</mat-label>
                <textarea matInput formControlName="reasonTwo"></textarea>
                <mat-error *ngIf="
                    formService.certificationForm
                      .get('reasonTwo')
                      ?.hasError('required')
                  ">
                  This field is required.
                </mat-error>
              </mat-form-field>
            </section>

            <!-- Question 3 -->
            <section class="toggle-state-options">
              <p>
                I understand that some Clinical sites may require immunization
                records or waivers.
              </p>
              <mat-radio-group formControlName="togglethree" (change)="onToggleCertification('Q3', $event.value)">
                <mat-radio-button value="Yes">Yes</mat-radio-button>
                <mat-radio-button value="No">No</mat-radio-button>
              </mat-radio-group>
              <mat-error *ngIf="
                  formService.certificationForm
                    .get('togglethree')
                    ?.hasError('required') &&
                  formService.certificationForm.get('togglethree')?.touched
                ">
                this field is required
              </mat-error>
              <mat-form-field *ngIf="toggleCertificationQthree" appearance="fill">
                <mat-label>Enter your reasons</mat-label>
                <textarea matInput formControlName="reasonThree"></textarea>
                <mat-error *ngIf="
                    formService.certificationForm
                      .get('reasonThree')
                      ?.hasError('required')
                  ">
                  This field is required.
                </mat-error>
              </mat-form-field>
            </section>

            <!-- Question 4 -->
            <section class="toggle-state-options">
              <p>
                I understand that certain clinical facilities may require
                COVID-19 vaccinations.
              </p>
              <mat-radio-group formControlName="togglefour" (change)="onToggleCertification('Q4', $event.value)">
                <mat-radio-button value="Yes">Yes</mat-radio-button>
                <mat-radio-button value="No">No</mat-radio-button>
              </mat-radio-group>
              <mat-error *ngIf="
                  formService.certificationForm
                    .get('togglefour')
                    ?.hasError('required') &&
                  formService.certificationForm.get('togglefour')?.touched
                ">
                this field is required
              </mat-error>
              <mat-form-field *ngIf="toggleCertificationQfour" appearance="fill">
                <mat-label>Enter your reasons</mat-label>
                <textarea matInput formControlName="reasonFour"></textarea>
                <mat-error *ngIf="
                    formService.certificationForm
                      .get('reasonFour')
                      ?.hasError('required')
                  ">
                  This field is required.
                </mat-error>
              </mat-form-field>
            </section>

            <!-- Question 5 -->
            <section class="toggle-state-options">
              <p>
                I understand that as part of my education, I may be exposed to
                patients with contagious diseases.
              </p>
              <mat-radio-group formControlName="togglefive" (change)="onToggleCertification('Q5', $event.value)">
                <mat-radio-button value="Yes">Yes</mat-radio-button>
                <mat-radio-button value="No">No</mat-radio-button>
              </mat-radio-group>
              <mat-error *ngIf="
                  formService.certificationForm
                    .get('togglefive')
                    ?.hasError('required') &&
                  formService.certificationForm.get('togglefive')?.touched
                ">
                this field is required
              </mat-error>
              <mat-form-field *ngIf="toggleCertificationQfive" appearance="fill">
                <mat-label>Enter your reasons</mat-label>
                <textarea matInput formControlName="reasonFive"></textarea>
                <mat-error *ngIf="
                    formService.certificationForm
                      .get('reasonFive')
                      ?.hasError('required')
                  ">
                  This field is required.
                </mat-error>
              </mat-form-field>
            </section>

            <!-- Question 6 -->
            <section class="toggle-state-options">
              <p>
                I understand that during clinical rotations, I must adhere to
                all policies and procedures of the assigned clinical site.
              </p>
              <mat-radio-group formControlName="togglesix" (change)="onToggleCertification('Q6', $event.value)">
                <mat-radio-button value="Yes">Yes</mat-radio-button>
                <mat-radio-button value="No">No</mat-radio-button>
              </mat-radio-group>
              <mat-error *ngIf="
                  formService.certificationForm
                    .get('togglesix')
                    ?.hasError('required') &&
                  formService.certificationForm.get('togglesix')?.touched
                ">
                this field is required
              </mat-error>
              <mat-form-field *ngIf="toggleCertificationQsix" appearance="fill">
                <mat-label>Enter your reasons</mat-label>
                <textarea matInput formControlName="reasonSix"></textarea>
                <mat-error *ngIf="
                    formService.certificationForm
                      .get('reasonSix')
                      ?.hasError('required')
                  ">
                  This field is required.
                </mat-error>
              </mat-form-field>
            </section>

            <!-- Navigation Buttons -->
            <div class="btn-group">
              <button mat-flat-button class="mr-15 stepper-btn-back" matStepperPrevious>
                Back
              </button>

              <button [disabled]="isSubmittingCertificateAgreement|| !formService.certificationForm.valid"
                (click)="onSaveContinueLater(formService.certificationForm)" class="save-continue" type="submit">
                Save & Continue later</button>

              <button mat-flat-button class="daxa stepper-btn-next" type="submit"
                [disabled]="isSubmittingCertificateAgreement||formService.certificationForm.invalid">
                <span *ngIf="!isSubmittingCertificateAgreement">Save & Next</span><span
                  *ngIf="isSubmittingCertificateAgreement" class="loading-ellipsis">Saving<span
                    class="dot one">.</span><span class="dot two">.</span><span class="dot three">.</span></span>
              </button>

            </div>
          </form>
        </mat-step>
      </div>

      <!-- fifteenth stepper form Document uploads  -->
      <mat-step
        *ngIf="StudentApplicationData?.noDocumentsRequired === false || StudentApplicationData?.noDocumentsRequired === null"
        [stepControl]="formService.documentUploadForm">
        <form [formGroup]="formService.documentUploadForm" (ngSubmit)="onSubmit(formService.documentUploadForm)">
          <ng-template matStepLabel class="template--header">
            <div class="template--header">
              <mat-icon *ngIf="formService?.documentUploadForm?.valid" class="valid">
                check
              </mat-icon>
              <mat-icon class="asterisk invalid" *ngIf="formService?.documentUploadForm?.invalid">close</mat-icon><label
                class="label-head">Document
                Uploads</label>
            </div>
          </ng-template>
          <div *ngIf="StudentApplicationData?.reqHighSchoolDipGed" class="doc-bg">
            <app-ng-fileupload [isMultiple]="false" [labelText]="'High school diploma certificate /GED'"
              fileId="highSchoolTranscript" [fileBlobUrl]="highSchoolTranscriptBlobUrl"
              [fileName]="StudentApplicationData?.highSchoolDiplomaUploadName" (filesSelected)="
                  handleFiles(
                    $event,
                    formService.documentUploadForm,
                    'highSchoolTranscript'
                  )
                " [control]="
                  $any(
                    formService.documentUploadForm.get('highSchoolTranscript')
                  )
                " error="Highschool transcript required">
            </app-ng-fileupload>
          </div>
          <div *ngIf="StudentApplicationData?.reqCollegeTrans" class="doc-bg">
            <app-ng-fileupload [isMultiple]="false" labelText="College transcript" fileId="collegeTranscript"
              [fileBlobUrl]="collegeTranscriptBlobUrl" [fileName]="StudentApplicationData?.collegeTranscriptUploadName"
              (filesSelected)="
                  handleFiles(
                    $event,
                    formService.documentUploadForm,
                    'collegeTranscript'
                  )
                " [control]="
                  $any(formService.documentUploadForm.get('collegeTranscript'))
                " error="College Transcript required">
            </app-ng-fileupload>
          </div>
          <div *ngIf="StudentApplicationData?.reqCNALicense" class="doc-bg">
            <app-ng-fileupload [isMultiple]="false" labelText="CNA License" fileId="cna" [fileBlobUrl]="cnaLiscenceUrl"
              [fileName]="StudentApplicationData?.cnaLicenceName" (filesSelected)="
                  handleFiles(
                    $event,
                    formService.documentUploadForm,
                    'cna'
                  )
                " [control]="
                  $any(formService.documentUploadForm.get('cna'))
                " error="CNA Liscence required">
            </app-ng-fileupload>
          </div>
          <div *ngIf="StudentApplicationData?.reqSSNDoc" class="doc-bg">
            <app-ng-fileupload [isMultiple]="false" labelText="Social Security Card/ SSN Replacement Letter."
              fileId="ssn" [fileBlobUrl]="ssnBlobUrl" [fileName]="
                  StudentApplicationData?.socialSecurityCardUploadName
                " (filesSelected)="
                  handleFiles($event, formService.documentUploadForm, 'ssn')
                " [control]="$any(formService.documentUploadForm.get('ssn'))" error="social security number required">
            </app-ng-fileupload>
          </div>
          <div *ngIf="StudentApplicationData?.reqGovPhotoId" class="doc-bg">
            <app-ng-fileupload [isMultiple]="false" labelText="Current Photo ID Issued by State/Federal Government."
              fileId="Id" [fileBlobUrl]="IdBlobUrl" [fileName]="StudentApplicationData?.governmentIDUploadName"
              (filesSelected)="
                  handleFiles($event, formService.documentUploadForm, 'Id')
                " [control]="$any(formService.documentUploadForm.get('Id'))" error="Id required">
            </app-ng-fileupload>
          </div>
          <div *ngIf="StudentApplicationData?.reqPhysicalExam" class="doc-bg">
            <app-ng-fileupload [isMultiple]="false" labelText="Vaccination Records" fileId="physicalExam"
              [fileBlobUrl]="physicalExamUploadUrl" [fileName]="StudentApplicationData?.reqPhysicalExamUploadName"
              (filesSelected)="
                  handleFiles($event, formService.documentUploadForm, 'physicalExam')
                " [control]="$any(formService.documentUploadForm.get('physicalExam'))"
              error="Vaccination Records required">
            </app-ng-fileupload>
          </div>
          <div *ngIf="StudentApplicationData?.reqHealthScreen" class="doc-bg">
            <app-ng-fileupload [isMultiple]="false" labelText="TB Skin Screen / Blood Test / X-Ray"
              fileId="healthScreen" [fileBlobUrl]="healthScreenUploadUrl"
              [fileName]="StudentApplicationData?.reqHealthScreenUploadName" (filesSelected)="
                  handleFiles($event, formService.documentUploadForm, 'healthScreen')
                " [control]="$any(formService.documentUploadForm.get('healthScreen'))"
              error="TB Skin Screen / Blood Test / X-Ray required">
            </app-ng-fileupload>
          </div>
          <div *ngIf="StudentApplicationData?.reqBLS" class="doc-bg">
            <app-ng-fileupload [isMultiple]="false" labelText="BLS (American Heart Association)" fileId="bls"
              [fileBlobUrl]="blsUploadUrl" [fileName]="StudentApplicationData?.reqBLSUploadName" (filesSelected)="
                  handleFiles($event, formService.documentUploadForm, 'bls')
                " [control]="$any(formService.documentUploadForm.get('bls'))"
              error="BLS (American Heart Association) required">
            </app-ng-fileupload>
          </div>
          <div *ngIf="StudentApplicationData?.reqBackgroundCheck" class="doc-bg">
            <app-ng-fileupload [isMultiple]="false" labelText="Background Check" fileId="backgroundCheck"
              [fileBlobUrl]="backgroundCheckUploadUrl" [fileName]="StudentApplicationData?.reqBackgroundCheckUploadName"
              (filesSelected)="
                  handleFiles($event, formService.documentUploadForm, 'backgroundCheck')
                " [control]="$any(formService.documentUploadForm.get('backgroundCheck'))"
              error="Background Check required">
            </app-ng-fileupload>
          </div>
          <div *ngIf="StudentApplicationData?.reqDrugScreen" class="doc-bg">
            <app-ng-fileupload [isMultiple]="false" labelText="Drug Screening Results" fileId="drugScreen"
              [fileBlobUrl]="drugScreenUploadUrl" [fileName]="StudentApplicationData?.reqDrugScreenUploadName"
              (filesSelected)="
                  handleFiles($event, formService.documentUploadForm, 'drugScreen')
                " [control]="$any(formService.documentUploadForm.get('drugScreen'))"
              error="Drug Screening Results required">
            </app-ng-fileupload>
          </div>
          <div class="btn-group">
            <button mat-flat-button color="warn" class="mr-15 stepper-btn-back" matStepperPrevious>
              Back
            </button>

            <button [disabled]="isSubmittingDocuments|| formService.documentUploadForm.invalid"
              (click)="onSaveContinueLater(formService.documentUploadForm)" class="save-continue" type="submit">
              Save & Continue later</button>
            <button mat-flat-button class="daxa stepper-btn-next" type="submit"
              [disabled]="isSubmittingDocuments||formService.documentUploadForm.invalid">
              <span *ngIf="!isSubmittingDocuments">Save & Next</span><span *ngIf="isSubmittingDocuments"
                class="loading-ellipsis">Saving<span class="dot one">.</span><span class="dot two">.</span><span
                  class="dot three">.</span></span>
            </button>

          </div>
        </form>
      </mat-step>

      <!-- sixteenth stepper form Discrimination  -->
      <mat-step>
        <form>
          <ng-template matStepLabel class="template--header">
            <div class="template--header">
              <mat-icon class="valid"> check </mat-icon><label class="label-head">Discrimination</label>
            </div>
          </ng-template>
          <p>
            {{ (tenant$ | async)?.name || 'The Institution' }} complies with Civil Rights Laws (Title VI
            and Title VII of the Civil Rights Act of 1964, Title IX of the
            Education Amendments of 1972, the Americans with Disabilities Act
            (“ADA”), the Age Discrimination in Employment Act, and Section 504
            of the Rehabilitation Act of 1973) MTC prohibits any form of
            discrimination, except to the extent permitted by law. The School
            shall not discriminate against any applicant based on Disability,
            Sex, Sexual Orientation, Social Economic Status, Familial Status,
            Gender Expression, Color, Creed, Age, Marital status, Veteran
            status, or Nationality in its Admission process, grading, or any
            other form while a student is enrolled. Anyone who feels
            discriminated against in any way, shape, or form must contact the
            College President.
          </p>
          <div class="btn-group">
            <button mat-flat-button color="warn" class="mr-15 stepper-btn-back" matStepperPrevious>
              Back
            </button>

            <button (click)="onSaveContinueLater()" class="save-continue" type="submit">
              Save & Continue later</button><button mat-flat-button class="daxa stepper-btn-next" matStepperNext>
              Save & Next
            </button>
          </div>
        </form>
      </mat-step>
      <!-- seventeenth stepper form Statement of understanding  -->
      <mat-step [stepControl]="formService.statementOfUnderstandingForm">
        <form [formGroup]="formService.statementOfUnderstandingForm"
          (ngSubmit)="onSubmit(formService.statementOfUnderstandingForm)">
          <ng-template matStepLabel class="template--header">
            <div class="template--header">
              <mat-icon *ngIf="formService?.statementOfUnderstandingForm?.valid" class="valid">
                check
              </mat-icon>
              <mat-icon class="asterisk invalid"
                *ngIf="formService?.statementOfUnderstandingForm?.invalid">close</mat-icon><label
                class="label-head">Statement Of Understanding</label>
            </div>
          </ng-template>
          <div style="display: flex">
            <mat-checkbox [formControl]="
                $any(
                  formService.statementOfUnderstandingForm.get(
                    'isTermsAndConditions'
                  )
                )
              " (change)="onStatementOfUnderstandingChecked($event.checked)"></mat-checkbox>
            <p>
              I certify that I have read, understood, and completed this student
              application form and that all the information provided is complete
              and accurate to the best of my knowledge. I further understand
              that providing false information is grounds for denying admission
              or terminating my enrollment Agreement. I certify that all
              documents submitted supporting this Application are true to the
              best of my knowledge. By signing this Student Application, I agree
              that I have read, understood, and completed this Student
              Application.
            </p>
          </div>

          <div class="btn-group">
            <button mat-flat-button color="warn" class="mr-15 stepper-btn-back" matStepperPrevious>
              Back
            </button>

            <button [disabled]="formService.statementOfUnderstandingForm.invalid" (click)="
                onSaveContinueLater(formService.statementOfUnderstandingForm)
              " class="save-continue" [disabled]="!statementChecked" type="submit">
              Save & Continue later
            </button>
            <button mat-flat-button type="submit"
              [disabled]="isSubmittingUnderstanding  || formService.statementOfUnderstandingForm.invalid"
              class="daxa stepper-btn-next">
              <span *ngIf="!isSubmittingUnderstanding">Save & Next</span><span *ngIf="isSubmittingUnderstanding"
                class="loading-ellipsis">Saving<span class="dot one">.</span><span class="dot two">.</span><span
                  class="dot three">.</span></span>
            </button>

          </div>
        </form>
      </mat-step>
      <!-- eighteenth stepper form Applicants signature  -->
      <mat-step [stepControl]="formService.signatureForm">
        <form [formGroup]="formService.signatureForm" (ngSubmit)="onSubmit(formService.signatureForm)">
          <ng-template matStepLabel class="template--header">
            <div class="template--header">
              <mat-icon *ngIf="formService?.signatureForm?.valid" class="valid">
                check
              </mat-icon>
              <mat-icon class="asterisk invalid" *ngIf="formService?.signatureForm?.invalid">close</mat-icon><label
                class="label-head">Applicant's Signature</label>
            </div>
          </ng-template>
          <!-- <p><strong style="text-decoration: underline; text-underline-offset: 4px;">NOTE:</strong> Sign your
            application by using either your name or the signature pad</p> -->

          <!-- <div class="row-batch">
            <div class="form-group">
              <app-signature-pad #signature [control]="$any(formService.signatureForm.get('signature'))"
                (signatureSaved)="handleSignatureSaved($event)" [width]="600" [height]="200"></app-signature-pad>
            </div>
          </div> -->
          <div class="row-batch">
            <div class="form-group">
              <mat-form-field appearance="fill" class="mat-input-body">
                <mat-label>Full Name</mat-label>
                <input matInput type="text" [formControl]="
                                $any(formService.signatureForm.get('fullname'))
                              " />
                <mat-error *ngIf="
                                formService.signatureForm
                                  .get('fullname')
                                  ?.hasError('required')
                              ">
                  fullname is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row-batch">
            <app-date-picker appearance="fill" (dateSelected)="onDateSelected($event)" [limitToToday]="true"
              placeholder="Date" [dateControl]="
                              $any(formService.signatureForm.get('signatureDate'))
                            " error="Date is required"></app-date-picker>
          </div>

          <div class="btn-group">
            <button mat-flat-button color="warn" class="mr-15 stepper-btn-back" matStepperPrevious>
              Back
            </button>
            <button mat-flat-button class="daxa stepper-btn-review">
              Review
            </button>

            <button mat-flat-button class="daxa stepper-btn-next" type="submit"
              [disabled]="isSubmittingSignature || formService.signatureForm.invalid">
              <span *ngIf="!isSubmittingSignature">Submit</span><span *ngIf="isSubmittingSignature"
                class="loading-ellipsis">Saving<span class="dot one">.</span><span class="dot two">.</span><span
                  class="dot three">.</span></span>
            </button>

          </div>
        </form>
      </mat-step>
    </mat-vertical-stepper>
  </section>
</mat-card>